// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { IonCol, IonRow } from "@ionic/react"
import { LandingPageGrid, useSession } from "../../../lib"
import { ConsoleSectionContainer, DashboardJumbotron, LoginComponent } from "../components"
import { useAccount } from "../context"
import ConsoleSectionPage from "./ConsoleSectionPage"


const Dashboard: React.FC = () => {
  const session = useSession()
  const {user} = session
  const {accounts} = useAccount()
  return (
    <ConsoleSectionPage>
      <ConsoleSectionContainer
        loginComponent={LoginComponent}
        nopadding
        ready={true}
      >
        <LandingPageGrid>
          <IonRow className="main section-padding-x">
            <IonCol>
              <DashboardJumbotron accounts={accounts} user={user}/>
            </IonCol>
          </IonRow>
        </LandingPageGrid>
      </ConsoleSectionContainer>
    </ConsoleSectionPage>
  )
}


export { Dashboard }